module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Lost-Treasures-of-the-Maya.7ea46b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Lost-Treasures-of-the-Maya.jpg
// module id = SG5N
// module chunks = 0